import React, {Suspense} from 'react'
import ReactDOM from 'react-dom'
import {ThemeProvider, withTheme} from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { getThemeColors } from './components/Common/colors'
import './polyfills'
let ID = 0;

export default  class AppWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            theme: {
                mode: 'light',
                margin: {
                    default: '15px',
                    large: '32px'
                },
                colors: getThemeColors()
            }
        };
        this.ID = ID++;
    }

    componentDidMount() {
        // Hack, use jQuery custom components to update the theme:
        const self = this;
        $( document ).on( "colorUpdate", {
            foo: "bar"
        }, function( event, colors, arg2 ) {
            console.log('Color update', self, colors); //
            self.setState ( (state) => {
                state.theme.colors = colors;

                // Need updated obj to refresh the components:
                state.theme = JSON.parse(JSON.stringify(state.theme));
                return state;
            })
        });
    }
    render () {
        console.log('THEME', this.ID, this.state.theme);
        return <Suspense fallback={<>Loading</>}>
            <I18nextProvider i18n={i18n}>
                <ThemeProvider theme={this.state.theme}>
                    {this.props.children}
                </ThemeProvider>
            </I18nextProvider>
        </Suspense>
    }
}